<template>
  <AddressesManager class="mb-32" />
  <AddressRules />
</template>

<script setup lang="ts">
import AddressRules from './components/AddressRules/AddressRules.vue'
import AddressesManager from './components/AddressesManager/AddressesManager.vue'
</script>
